export default {
  /** 销售订单、运单等统计数据 */
  getStatsAll: '/api/dashboard/stats',
}
